module.exports = __webpack_public_path__ + "img/bg-landing.06a3d843.png";